export const domainName = process.env.DEFAULT_DOMAIN == 'localhost' ? 'localhost:3000' : process.env.DEFAULT_DOMAIN
export const hostName = process.env.DEFAULT_DOMAIN == 'localhost' ? 'http://localhost:3000' : `https://${process.env.DEFAULT_DOMAIN}`
